import React from "react";
import { Recycle } from "lucide-react";
import WasteSolutionCard from "@/components/professions/WasteSolutionCard";

interface MetierSolutionsProps {
  profession: {
    wasteMaterials: Array<{
      type: string;
      description: string;
      solutions: string[];
      environmentalBenefit: string;
    }>;
  };
}

const MetierSolutions = ({ profession }: MetierSolutionsProps) => {
  return (
    <section className="mb-16">
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
        <div className="bg-gradient-to-r from-fabre-green to-fabre-teal p-8 text-white">
          <h2 className="text-3xl font-heading font-bold text-center flex items-center justify-center">
            <Recycle className="h-8 w-8 mr-4" />
            Solutions de valorisation adaptées
          </h2>
          <div className="w-24 h-1 bg-white/30 mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="p-8">
          <div className="space-y-8">
            {profession.wasteMaterials.map((material, index) => (
              <div key={index}>
                <h3 className="text-2xl font-heading font-bold mb-4 text-fabre-gray">
                  {material.type}
                </h3>
                <WasteSolutionCard wasteMaterial={material} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MetierSolutions;